/**
 * ステップ見積もりのサムネイル画像アップロードヘルパー。
 *
 * purpose=tool_asset は register 不要（S3 URL をツールプリセット payload へ
 * 直接保持する）ため、共通の `uploadFileDirect` に委譲する。
 */
import {
  uploadFileDirect,
  type InitiateUploadTrigger,
  type UploadedFile,
} from "../../../../utils/s3DirectUpload";

/**
 * 画像 1 件を purpose=tool_asset で S3 へアップロードし、公開 URL を返す。
 *
 * @param initiate uploadApi の initiateUpload mutation trigger（`.unwrap()` 可能なもの）
 */
export const uploadToolAsset = (
  initiate: InitiateUploadTrigger,
  file: File,
): Promise<UploadedFile> =>
  uploadFileDirect(initiate, file, {
    purpose: "tool_asset",
    tooLargeMessage: "サムネイルに使える画像は 50MB 未満のみです",
  });
